/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { Fragment, useState, useEffect } from 'react';
// eslint-disable-next-line
import { Row, Col, TabContent, TabPane, Nav, NavItem, NavLink, Table } from 'reactstrap'; // eslint-disable-next-line
import avatar_img from '../../assets/img/team/avatar.svg'; // eslint-disable-next-line
import Badge from 'reactstrap/es/Badge'; // eslint-disable-next-line
import { copiriAxiosPost, copiriPortalRequest } from '../api/api'; // eslint-disable-next-line
import config from '../config/config'; // eslint-disable-next-line
import CopiriLoader from '../common/CopiriLoader'; // eslint-disable-next-line
import default_avatar from '../../assets/img/team/avatar.svg'; // eslint-disable-next-line
const UserProfileMeetingAttendance = props => {
	// eslint-disable-next-line
	const { data, pageLanguageContent, profileId, currentActiveTab } = props;
	const [userAttendance, setUserAttendance] = useState([]);
	const [loader, setLoader] = useState(true);
	useEffect(() => {
		getUserAttendanceData(profileId, setUserAttendance, 'all');
		// eslint-disable-next-line
	}, [props]);

	/* function to call api to get user event attendance */
	function getUserAttendanceData(id, method, type) {
		setLoader(true);
		copiriPortalRequest('/users/' + id + '/attendance/' + type, config.app_version, 'get')
			.then(response => {
				setLoader(false);
				if (response?.data?.total > 0) {
					method(response?.data?.visits);
				} else {
					method([]);
				}
			})
			.catch(error => {
				setLoader(false);
				method([]);
			});
	}

	return (
		<fieldset className='border p-2'>
			<legend className='w-auto'>{pageLanguageContent['PRL162'] ? pageLanguageContent['PRL162'] : ''}</legend>
			{loader ? (
				<CopiriLoader />
			) : (
				<Row>
					{userAttendance &&
						userAttendance.length > 0 &&
						userAttendance.map((item, i) => (
							<Col xs={12}>
								<span>{item?.title} </span>
								<span>- {item?.type} </span>
								<span>
									<br /> {item?.parent_name} {item.parent_name && item?.organization_name && <> - </>}{' '}
									{item?.organization_name}{' '}
								</span>
								<span>
									<br /> {item?.date_text}{' '}
								</span>
							</Col>
						))}
					{userAttendance && userAttendance.length <= 0 && (
						<Col xs={12} className='text-center'>
							<span className='user_profile_text'>
								{pageLanguageContent['PRL169'] ? pageLanguageContent['PRL169'] : ''}
							</span>
						</Col>
					)}
				</Row>
			)}
		</fieldset>
	);
};
export default UserProfileMeetingAttendance;
